var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartStyleRange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.28571 11.5714L7.42857 10.1429M2 4.14286V11V4.14286ZM0 9.57143H2H0ZM4 4.42857H2H4ZM7.14286 0.714287V7.57143V0.714287ZM5.14286 2.71429H7.14286H5.14286ZM9.14286 7.28571H7.14286H9.14286ZM6.57143 10.1429H7.71429C7.86584 10.1429 8.01118 10.0827 8.11835 9.97549C8.22551 9.86833 8.28571 9.72298 8.28571 9.57143C8.28571 9.41988 8.22551 9.27453 8.11835 9.16737C8.01118 9.0602 7.86584 9 7.71429 9H6.57143V11.5714V10.1429Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartStyleRange);
export default __webpack_public_path__ + "static/media/chart-style-range.471650fd1964dbb451a0a291d03a9dc8.svg";
export { ForwardRef as ReactComponent };